<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label">
        <p class="text">
          {{ this.$store.getters.TRANSLATIONS["payment_methods"] }}
        </p>
      </div>
      <p class="content_title">
        {{ this.$store.getters.TRANSLATIONS["your_payment_methods"] }}
      </p>
      <div v-if="cards.length === 0" class="no_info">
        <img :src="parkendaLogo" />
        <p>
          {{ this.$store.getters.TRANSLATIONS["no_payments_on"] }}
          <br />{{ this.$store.getters.TRANSLATIONS["add_payment_method"] }}
        </p>
      </div>
      <div v-for="item in cards" :key="item.id" v-on:click="next(item)">
        <div class="card">
          <button class="button start">{{ item.number || "" }}</button>
          <button v-if="defaultCardId === item.id" class="button end">
            default
          </button>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!loading">
      <button v-on:click="addCard()" class="button">
        {{ this.$store.getters.TRANSLATIONS["add_new_card"] }}
      </button>
    </div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar v-if="!loading"></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created() {
    if (this.$route.query && this.$route.query.token) {
      this.$store.dispatch("SAVE_TOKEN", this.$route.query.token);
      this.$storage.set("parkendaToken", this.$route.query.token);
      return;
    }
    const timeout = setTimeout(() => {
      this.loading = true;
    }, 0);
    this.$http
      .get(`${process.env.SERVER_URL}/57A14732CFFD4C9E9B5EA5D3741F0954`, {
        headers: {
          "x-access-token": this.$storage.get("parkendaToken")
        }
      })
      .then((response) => {
        console.log("Get user cards response:");
        console.log(response);
        if (response.data) {
          this.cards = response.data;
          this.defaultCardId = this.$store.getters.USER
            ? this.$store.getters.USER.defaultCardId
            : null;
        } else {
          console.log("Can't get cards list from Squareup.com");
        }
      })
      .then(() => {
        return this.$http
          .get(`${process.env.SERVER_URL}/2600ED9F52C14E3D929B271668DE977E`, {
            headers: {
              "x-access-token": this.$storage.get("parkendaToken")
            }
          })
          .then((response) => {
            console.log("Get current user response:");
            console.log(response);
            if (response.data) {
              this.$store.dispatch("SAVE_USER", response.data);
              this.defaultCardId = response.data.defaultCardId;
            }
          });
      })
      // .catch((error) => {
      //   console.log(error);
      //   let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
      //   this.$modal.show("dialog", {
      //     text,
      //     buttons: [
      //       {
      //         title: "OK",
      //         handler: () => {
      //           this.$storage.remove("parkendaToken");
      //           this.$router.push("/login");
      //         }
      //       }
      //     ]
      //   });
      // })
      .finally(() => {
        clearTimeout(timeout);
        this.loading = false;
      });
  },
  // created: function() {
  //   if (!this.$storage.get("parkendaToken") || !this.$store.getters.USER) {
  //     this.$router.push("/login");
  //   }
  // },
  data() {
    return {
      loading: true,
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      parkendaLogo: require("@/assets/new_design/Parkenda_Brandmark_Black.png"),
      cards: [],
      defaultCardId: null,
      cardIcon: require("@/assets/cardIcon.png"),
      next: (item) => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .get(
            `${process.env.SERVER_URL}/5D7F93F0081B40FF9AD2B5D57169EDCE/${item.id}`,
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Get card by id response:");
            console.log(response);
            let User = this.$store.getters.USER;
            User.selectedCard = item;
            this.$store.dispatch("SAVE_USER", User);
            this.$router.push("/cardEditSquare");
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["something_went_wrong"];
            if (
              error.response &&
              error.response.data &&
              error.response.data.error
            ) {
              text = error.response.data.error;
            }
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$storage.remove("parkendaToken");
                    this.$router.push("/login");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      addCard: () => {
        this.$router.push("/cardAddSquare?returnTo=cardsListSquare");
      },
      back: () => {
        this.$router.go(-1);
      },
      icon: require("@/assets/icon_back.png"),
      nextIcon: require("@/assets/nextArrowIos.jpg")
    };
  }
};
</script>

<style src="../../styles/main.css"></style>
<style scoped>
.card {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.start {
  width: 50%;
  background-color: white;
  color: #fbae31;
  text-align: left;
  padding-left: 10px;
  margin-left: 17vw;
}
.end {
  position: absolute;
  width: 20%;
  margin-left: 55vw;
  background-color: #fbae31;
  color: white;
}
.no_info {
  margin-top: 5vh;
}
.no_info p {
  color: white;
}
</style>



// WEBPACK FOOTER //
// src/components/Cards/List.vue